import * as React from 'react';
import { connect } from 'react-redux';
import { format, getQuarter } from 'date-fns';

import { IFilters } from '../../../interfaces';
import { QuarterlyFormModel } from '../../../model/QuarterlyFormModel';
import { getQuarterlyFormDetails } from '../../../services/quarterlyFormService';
import { DetailsPageWrapper } from '../../reusableComponents/DetailsPageWrapper';
import { getQuarterText, getPageTitle } from '../../../utils/generalUtils';

export interface IDetailsPageProps {
    id: string;
    instance: QuarterlyFormModel;
    filters: IFilters;
}

export class DetailsPageImpl extends React.PureComponent<IDetailsPageProps, {}> {

    static defaultProps: IDetailsPageProps;

    promise = async () => {
        await getQuarterlyFormDetails(this.props.id);
    }

    render() {
        const { instance } = this.props; 
        let title = 'Quarterly Form Details';
        if(instance) {  
            //title = `${title} ${getQuarterText(getQuarter(new Date(format(instance.props.Date,'YYYY-MM-DD') ) ) ) } ${format(instance.props.Date,'YYYY')}`;
            title = `${getPageTitle(instance.props.type, 'quarterly', instance.props.Date, 'report')} `;
        }
        return (
            <DetailsPageWrapper
                id=""
                pageTitle={title}
                backTo="quarterly"
                formType="quarterly"
                instance={instance}
                promise={this.promise}
            />
        );
    }
}

export function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    
    const instance = QuarterlyFormModel.get(id);
    return {
        instance, id
    };
}

export const DetailsPage = connect<{}, {}, IDetailsPageProps>(mapStateToProps)(DetailsPageImpl as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Reports/Quarterly/DetailsPage.tsx